import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import MaterialRadio from "@material-ui/core/Radio";
import {withStyles} from "@material-ui/core";

const materialStyles = {
  root: {
    "color": `#696f6f !important`,
    "padding": `12px`,
    "&:hover": {
      backgroundColor: `transparent`
    }
  },
  icon: {
    "borderRadius": `50%`,
    "width": 20,
    "height": 20,
    "backgroundColor": `#ebecec`,
    "$root.Mui-focusVisible &": {
      outline: `2px auto rgba(19,124,189,.6)`,
      outlineOffset: 2
    },
    "input:hover ~ &": {
      backgroundColor: `#ebf1f5`
    },
    "input:disabled ~ &": {
      boxShadow: `none`,
      background: `rgba(206,217,224,.5)`
    }
  },
  checkedIcon: {
    "backgroundColor": `#696f6f`,
    "display": `flex`,
    "alignItems": `center`,
    "justifyContent": `center`,
    "&:before": {
      display: `block`,
      width: 8,
      height: 8,
      borderRadius: `50%`,
      backgroundColor: `#fff`,
      content: `""`
    },
    "input:hover ~ &": {
      backgroundColor: `#ebecec`
    }
  }
};

function Radio(props) {
  const {classes, ...rest} = props;
  return (
    <MaterialRadio
      className={classes.root}
      checkedIcon={
        <span className={classNames(classes.icon, classes.checkedIcon)} />
      }
      icon={<span className={classes.icon} />}
      {...rest}
    />
  );
}

Radio.propTypes = {
  classes: PropTypes.object
};

export default withStyles(materialStyles)(Radio);
